import React from "react";
import { TextField } from "@mui/material";

function CustomTextArea(props) {
  return (
    <TextField
      //   label="Enter your message"
      label={props.label}
      onChange={props.onChange}
      onKeyDown={props.onKeyDown}
      value={props.value}
      multiline
      rows={props.props || 4}
      fullWidth
      variant="outlined"
      margin="normal"
      sx={{
        "& .MuiOutlinedInput-root": {
          borderRadius: "12px",
          "& fieldset": {
            borderColor: "#14bc9a", // Default border color
          },
          "&:hover fieldset": {
            borderColor: "#119a80", // Border color on hover
          },
          "&.Mui-focused fieldset": {
            borderColor: "#ff9800", // Border color when focused
          },
        },
        "& .MuiInputLabel-root": {
          color: "#14bc9a", // Label color
        },
        "& .MuiInputLabel-root.Mui-focused": {
          color: "#ff9800", // Label color when focused
        },
      }}
    />
  );
}

export default CustomTextArea;
